import app from 'flarum/forum/app';
import registerWidget from '../common/registerWidget';

// [swtor-polska.pl] goście online: przeglądarka co 2 minuty wysyła krótki sygnał
// (gość zostaje policzony, każdy dostaje aktualną liczbę gości).
//
// Wersja 2.0.0.2:
// - błąd sygnału (np. chwilowy 502 albo wygasła sesja) NIE pokazuje już
//   czerwonego komunikatu „Ups! Coś poszło nie tak” — sygnał jest w tle,
// - po kilku błędach z rzędu odstęp rośnie (2 → 4 → 8 → max 15 min),
// - przełączanie kart nie wysyła serii zapytań (najwyżej 1 na minutę),
// - nie działa w ukrytej karcie.
const BASE_INTERVAL = 2 * 60 * 1000;
const MAX_INTERVAL = 15 * 60 * 1000;
const MIN_GAP = 60 * 1000;
let lastPing = 0;
let failures = 0;
let timer = null;
let inFlight = false;

// UWAGA: app.forum jest dostępne dopiero PO uruchomieniu initializerów,
// więc ustawienie czytamy dopiero w momencie wysyłania sygnału.
function enabled() {
  return !!app.forum && app.forum.attribute('fof-forum-statistics-widget.showGuestsOnline') !== false;
}
function schedule(delay) {
  if (timer) clearTimeout(timer);
  timer = setTimeout(tick, delay);
}
function nextDelay() {
  return Math.min(BASE_INTERVAL * Math.pow(2, failures), MAX_INTERVAL);
}
function pingGuests() {
  if (inFlight || document.hidden || !enabled()) return;
  if (Date.now() - lastPing < MIN_GAP) return;
  inFlight = true;
  lastPing = Date.now();
  app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/fof-forum-statistics/guests-ping',
    background: true,
    // bez czerwonego alertu przy błędzie — to tylko sygnał w tle
    errorHandler: () => {}
  }).then(res => {
    failures = 0;
    if (res && typeof res.guests === 'number' && res.guests !== app.fofGuestsOnline) {
      app.fofGuestsOnline = res.guests;
      m.redraw();
    }
  }).catch(() => {
    failures = Math.min(failures + 1, 4);
  }).finally(() => {
    inFlight = false;
  });
}
function tick() {
  pingGuests();
  schedule(nextDelay());
}
app.initializers.add('fof/forum-statistics-widget', () => {
  registerWidget();
  schedule(3000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) pingGuests();
  });
});